// extracted by mini-css-extract-plugin
module.exports = {"box":"NewPass_box__2C-hw","title":"NewPass_title__1Kwik","button":"NewPass_button__3LmjD","link":"NewPass_link__128Ap"};